<template>
    <div class="content-area">
        <div class="form-layout">
            <div class="form-info">
                <el-form :model="ruleForm" ref="ruleForm" class="demo-ruleForm">
                    <div class="form-row">
                        <div class="form-label">
                            <label class="required">审核操作</label>
                        </div>
                        <div class="form-value width-1-5x">
                            <el-form-item prop="auditState">
                                <el-radio-group v-model="ruleForm.auditState">
                                    <el-radio label="1">通过</el-radio>
                                    <el-radio label="-1">驳回</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                    </div>
                    <!--<div v-if="ruleForm.auditState == 1" class="form-row">-->
                    <!--<div class="form-label">-->
                    <!--<label>&nbsp;</label>-->
                    <!--</div>-->
                    <!--<div class="form-value">-->
                    <!--<el-form-item prop="updateOrgNetWorthFlag">-->
                    <!--<el-checkbox v-model="updateOrgNetWorthFlag">更新单原值单净值</el-checkbox>-->
                    <!--</el-form-item>-->
                    <!--</div>-->
                    <!--</div>-->
                    <div class="form-row" v-if="!crossComFlag&&ruleForm.auditState == 1 && lowCostFlag">
                        <div class="form-label">
                            <label>&nbsp;</label>
                        </div>
                        <div class="form-value">
                            <el-form-item prop="auditState">
                                <el-checkbox v-model="confirmState">调入自动确认</el-checkbox>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-row" style="height: 88px">
                        <div class="form-label">
                            <label class="">原因</label>
                        </div>
                        <div class="form-value width-1-5x">
                            <el-form-item prop="desc">
                                <el-input type="textarea" v-model="ruleForm.desc"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import assetVchrApi from '../../api/assetVchr'

    export default {
        name: 'swb-shop-device-trans-voucher-audit',
        desc: '设备调拨单审核',
        props: ['crossComFlag', 'id', 'lowCostFlag'],
        data: function () {
            return {
                ruleForm: {
                    auditState: '1',
                },
                confirmState: true,
                updateOrgNetWorthFlag: false
            }
        },
        created: function () {
            if(!Utils.isNoB(this.id)) {
                this.getShopDeviceTransVoucher();
            }
        },
        methods: {
            getShopDeviceTransVoucher: function () {
                let self = this;
                let postData = {};
                postData.id = self.id;
                let theLoad = MsgBox.loading();
                assetVchrApi.getShopDeviceTransVoucherById(postData, function (result) {
                    theLoad.hide();
                    if(result.type == "info") {
                        //
                        let transVoucherInfo = result.data;
                        let itemList = transVoucherInfo.itemList || [];
                        if(transVoucherInfo.srcBizUnitId != transVoucherInfo.dstBizUnitId) {
                            self.crossComFlag = true;
                        }
                        for(let i = 0; i < itemList.length; i++) {
                            let item = itemList[i];
                            if(Utils.isNoB(item.dstComId)) {
                                self.crossComFlag = true;
                                break;
                            }
                            if(Utils.isNoB(item.dstWarehouseId)) {
                                self.crossComFlag = true;
                                break;
                            }
                            if(item.dstComId == item.srcComId && item.srcWarehouseId == item.dstWarehouseId) {
                                self.crossComFlag = true;
                                break;
                            }
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                result.type = "info";
                let ruleForm = self.ruleForm;
                if(!self.crossComFlag && ruleForm.auditState == 1) {
                    if(self.confirmState == false) {
                        ruleForm.confirm = 0;
                    } else {
                        ruleForm.confirm = 1;
                    }
                } else {
                    ruleForm.confirm = 0;
                }
                ruleForm.updateOrgNetWorthFlag = self.updateOrgNetWorthFlag;
                result.data = ruleForm;
                return result;
            }
        },
    }
</script>




// WEBPACK FOOTER //
// src/compo/transVoucher/ShopDeviceTransVoucherAudit.vue